import React from "react";
import { useSelector } from "react-redux";
import DataTable from "../components/UI/DataTable/DataTable";
import { GMT_TABLE_COLUMNS, CHARGE_ACCOUNTS_TABLE_COLUMNS } from "../constants/Constants";
import Activity from "../containers/UserInfo/Activity/Activity";
import GmtDetails from "../containers/UserInfo/Details/GmtDetails";
import { commonActions } from "../redux/reducers/CommonReducer";
import { TABLES, UTRON_PLARFORMS } from "../enums/Enums";
// import { parkersActions } from "../redux/reducers/ParkersReducer";
import { userActions } from "../redux/reducers/UserReducer";
import store from "../redux/Store";
import * as actionsService from "../services/ActionsService/ActionsService";
import { getChargeAccountsData } from "../utils/UsersUtils";

let isFetching = false;

export const fetchGmtUsersData = (scopeId, isFirstTimeLoading = false) => {
  if (!scopeId || isFetching) {
    return Promise.resolve();
  }

  isFetching = true;
  const gmtType = UTRON_PLARFORMS.GMT;

  return actionsService.getGmtUsersForAdmin(gmtType, scopeId, isFirstTimeLoading)
    .then((response) => {
      if (response.data.isSuccess) {
        let currentGmtUsers = response.data.entity.filter(user => user.userScopes.some(us => us.role.name !== "Charge Account"));
        store.dispatch(userActions.setCurrentGmtUsers(currentGmtUsers));
        
        let chargeAccounts = response.data.entity.filter(user => user.userScopes.some(us => us.role.name === "Charge Account"));
        let chargeAccountsIds = response.data.entity.filter(user => user.userScopes.some(us => us.role.name === "Charge Account")).map(user => user.utronUser.id);

        if (chargeAccountsIds.length > 0) {
          return actionsService.getChargeAccountsData(chargeAccountsIds, true, true)
            .then(response => {
              let currentChargeAccounts = getChargeAccountsData(chargeAccounts, response.data.entity);
              store.dispatch(userActions.setCurrentChargeAccounts(currentChargeAccounts));
              store.dispatch(commonActions.setIsFirstTimeLoading(false));
              isFetching = false;
            })
            .catch(error => {
              console.log(error);
              store.dispatch(commonActions.setIsFirstTimeLoading(false));
              isFetching = false;
            });
        } else {
          store.dispatch(commonActions.setIsFirstTimeLoading(false));
          isFetching = false;
        }
      } else {
        store.dispatch(commonActions.setIsFirstTimeLoading(false));
        isFetching = false;
      }
    })
    .catch(error => {
      console.log(error);
      store.dispatch(commonActions.setIsFirstTimeLoading(false));
      isFetching = false;
    });
};

const useGmtService = () => {
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const currentChargeAccounts = useSelector((state) => state.user.currentChargeAccounts);
  const gmtColumns = GMT_TABLE_COLUMNS;
  const chargeAccountsColumns = CHARGE_ACCOUNTS_TABLE_COLUMNS;
  const selectedScope = useSelector((state) => state.user?.selectedScope);

  const getGmtDataTable = (eventFn) => {
    return (
      <DataTable
        onRowClick={eventFn}
        columns={gmtColumns}
        rows={currentGmtUsers}
        tableId={TABLES.GMT}
        selectedScope={selectedScope}
      ></DataTable>
    );
  };

  const getChargeAccountsDataTable = (eventFn) => {
    return (
      <DataTable
        onRowClick={eventFn}
        columns={chargeAccountsColumns}
        rows={currentChargeAccounts}
        tableId={TABLES.CHARGE_ACCOUNTS}
        selectedScope={selectedScope}
      ></DataTable>
    );
  };

  const getGmtActivity = (props) => {
    return <Activity {...props}></Activity>;
  };

  const getGmtDetails = (props) => {
    return <GmtDetails {...props}></GmtDetails>;
  };

  return {
    getGmtDataTable,
    getChargeAccountsDataTable,
    getGmtActivity,
    getGmtDetails
  };
};

export default useGmtService;
